@if (viewAnnouncement) {
    <skl-icon name="exclamation-circle"></skl-icon>
    <p>
        {{ viewAnnouncement.text }} {{ viewAnnouncement.hrefText ? '- ' : '' }}
        <a
            [href]="viewAnnouncement.url"
            target="_blank">
            {{ viewAnnouncement.hrefText }}
        </a>
    </p>
}